import { render, staticRenderFns } from "./SecMenu.vue?vue&type=template&id=d6be41f0"
import script from "./SecMenu.vue?vue&type=script&lang=js"
export * from "./SecMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports